<template>
    <div class="login">
        <div class="container-center">
            <div class="login-inner">
                <el-row>
                    <el-col :span="12" class="login-type no-border" :class="{ active: tabitem}" @click.native="tabitem = true,resetForm('loginForm'),resetForm('businessForm')">
                        <div class="grid-content">供方入口</div>
                    </el-col>
                    <el-col :span="12" class="login-type" :class="{ active: !tabitem}" @click.native="tabitem = false,resetForm('loginForm'),resetForm('businessForm'),loginType = 1">
                        <div class="grid-content">甲方入口</div>
                    </el-col>
                </el-row>
                <div class="login-form">
                    <div class="form-title">
                        <div class="welcome">欢迎登录</div>
                        <div v-if="tabitem">
                            <el-radio-group v-model="loginType" size="mini">
                                <el-radio-button label="1">账号登录</el-radio-button>
                                <el-radio-button label="2">手机登录</el-radio-button>
                            </el-radio-group>
                        </div>
                    </div>
                    <template v-if="loginType == 1">
                        <el-form v-loading="$root.loading" :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="100px" class="loginForm">
                            <el-form-item label="账号:" prop="loginName"><i class="icon icon-name"></i>
                                <el-input type="text" v-model.trim="loginForm.loginName" auto-complete="off" @keydown.enter.native="login('loginForm')"></el-input>
                            </el-form-item>
                            <el-form-item label="密码:" prop="password"><i class="icon icon-pass"></i>
                                <el-input type="password" v-model="loginForm.password" auto-complete="off" @keydown.enter.native="login('loginForm')"></el-input>
                            </el-form-item>
                            <el-form-item label="验证码:" prop="imgCode" class="imgwarp"><i class="icon icon-code"></i>
                                <el-input v-model="loginForm.imgCode" :maxlength="4" @keydown.enter.native="login('loginForm')"></el-input>
                                <verify-code ref="imgCode"></verify-code>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class='submit' @click="login('loginForm')">立即登录</el-button>
                            </el-form-item>
                            <!-- <div class="error">{{ message }}</div> -->
                        </el-form>
                    </template>

                    <template v-if="loginType == 2 && tabitem">
                        <el-form v-loading="$root.loading" :model="businessForm" status-icon :rules="rules" ref="businessForm" label-width="100px" class="loginForm">
                            <el-form-item label="统一社会信用代码:" prop="businessCreditCode"  class="w-140"><i class="icon icon-name"></i>
                                <el-input type="text" v-model.trim="businessForm.businessCreditCode" auto-complete="off" placeholder="" ></el-input>
                            </el-form-item>
                            <el-form-item label="手机号:" prop="phone" class="w-110"><i class="icon icon-pass"></i>
                                <el-input type="text" v-model="businessForm.phone" :maxlength="11" auto-complete="off" placeholder="业务对接人手机号" ></el-input>
                            </el-form-item>
                            <el-row type="flex" justify="space-between">
                                <el-col :span="17">
                                    <el-form-item label="验证码:" prop="imgCode" class="imgwarp"><i class="icon icon-code"></i>
                                        <el-input v-model="businessForm.imgCode" :maxlength="4" ></el-input>
                                        <verify-code ref="imgCode"></verify-code>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="7" class="send-msg-col">
                                    <el-button type="primary" :disabled="isSendMsg" size="mini" class="send-msg-btn" @click="sendMessage">{{btnMsg}}</el-button>
                                </el-col>
                            </el-row>
                            <el-form-item label="短信验证码:" prop="msgCode" class="w-120"><i class="icon icon-pass"></i>
                                <el-input type="text" v-model="businessForm.msgCode" auto-complete="off" ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class='submit' @click="login('businessForm')">立即登录</el-button>
                            </el-form-item>
                        </el-form>
                    </template>

                    <div v-if="tabitem" class="forget"><span @click="$router.push('/forget')">忘记密码?</span></div>
                </div>
            </div>
        </div><!--container-center-->
        <form id="adminLoginForm" :action="`${(baseUrl.substring(0,baseUrl.length-1)).replace('139.217.207.66', 'em.dahuahome.com:8090')}/admin/a/login?loginFrom=rest`" method="post" >
        <!--<form id="adminLoginForm" :action="`http://58.210.98.35:9007/admin/a/login`" method="post" >-->
        <input type="hidden" name="username" value="" >
        <input type="hidden"  name="password" value="" >
        </form>
        <el-dialog title="为了您的账号安全，请先修改初始密码：" :visible.sync="firstBlood" width="80%" center
            :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <!--<h3></h3>-->
            <password :callback="afterLogin"></password>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import util from '@/util'
    import cookie from '@/util/cookie'
    import { mapMutations } from 'vuex'
    import { SUPPLIER_BASIC_FORM, SUPPLIER_USER_INFO } from '@/store/mutation-types'
    import VerifyCode from '@/components/VerifyCode'
    import Password from '@/pages/dsp/supplier/Password'

    export default {
        name: 'Login',
        data () {
            return {
                loginType:'1',
                loginForm:{
                    loginName: window.sessionStorage.getItem('loginName')||'',//'11161',
                    password: '',
                    imgCode:'',
                },
                isSendMsg:false, // 是否发送短信
                btnMsg:'获取验证码',
                businessForm:{
                    imgCode:'',
                    businessCreditCode:'', // 企业信用代码
                    phone:'',
                    msgCode:'' , // 短信验证码
                },
                src:'',
                tabitem: true,
                message: '',
                rules: {
                    loginName: [
                        { required: true, message: '请输入账号', trigger: 'change' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' },
                        { min: 3, message: '密码至少 3 位', trigger: 'blur'}
                    ],
                    imgCode: [
                        { required: true, message: '请输入4位验证码', trigger: 'blur' },
                        { validator: this.validateCode, message: '验证码不正确', trigger: 'blur'}
                    ],
                    businessCreditCode:[
                        { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
                    ],
                    phone:[
                        { required: true, message: '请输入业务对接人手机号', trigger: 'blur' },
                         { validator: 'regexp', pattern: /^1\d{10}$/, message: '手机号码不正确', trigger: 'blur' }
                    ],
                    msgCode:[
                        { required: true, message: '请输入短信验证码', trigger: 'blur' }
                    ],
                },

                baseUrl: util.baseUrl,
                firstBlood: false
            }
        },
        components:{verifyCode: VerifyCode, password: Password},
        watch:{
            loginType(val){
                let formName = val == 1 ? 'loginForm' : 'businessForm'
                this.$nextTick(()=>{
                    if (this.$refs[formName] !== undefined){
                        this.$refs[formName].resetFields();
                    }
                })

            }
        },
       methods: {
        ...mapMutations({setBasicInfo: SUPPLIER_BASIC_FORM, setUserInfo: SUPPLIER_USER_INFO}),
            validateCode(rule, value, callback){
                if(value.length==4){
                    let imgCode = this.$refs.imgCode
                    if(value.split('').every((v,i)=>{
                        return new RegExp(v, 'i').test(imgCode.codeChars.charAt(imgCode.codeIndex[i]))
                    })){
                        callback()
                    } else {
                        callback(new Error(rule.message))
                    }
                }else{
                    callback(new Error(rule.message))
                }
            },
            createRandomCode () {
                this.src = util.baseUrl+'rest/api/dspUserApi/verify/img?'+ +new Date;
            },
            resetForm(formName) {
                if(this.$refs[formName]){
                    this.$refs[formName].resetFields();
                }
                this.message = '';
            },

            sendMessage(){
                let validMsg = [];
                this.$refs.businessForm.validateField('phone',valid=> valid ? validMsg.push(valid) : null);
                this.$refs.businessForm.validateField('imgCode',valid=> valid ?  validMsg.push(valid) : null);
                if(!validMsg.length){
                    this.isSendMsg = true;
                    const totalTime = 60;
                    let index = 1;
                    this.btnMsg = (totalTime - index) + 's'
                    let timer = setInterval(() => {
                        if(index >= totalTime){
                            clearInterval(timer);
                            this.isSendMsg = false;
                            this.btnMsg = '获取验证码';
                            return
                        }
                        index++;
                        this.btnMsg = (totalTime - index) + 's'
                    }, 1000);
                    this.sendMessagePhone(this.businessForm.phone)
                }
            },

            // 发送验证码
            sendMessagePhone(phone){
                 this.$http.get(`/rest/api/dspUserApi/getLoginCode/${phone}`).then(data =>{
                     let message = data.data.message;
                     data.data.result ? this.$message.success(message) : this.$message.error(message);

                 })
            },

            // 校验验证码
            checkMsgCode(val){
                this.$http.get(`/rest/api/dspUserApi/checkLoginCode/${this.businessForm.phone}/${this.businessForm.msgCode}`).then(data =>{
                    let message = data.data.message;
                    data.data.result ? null : this.$message.error(message);

                })
            },

            login (formName) {
                if(this.tabitem){//
                    this.$refs[formName].validate(valid =>  {
                        if (valid) {
                            this.$root.loading = true;
                            let form = this.loginType == 1 ? Object.assign({type:1},this.loginForm) : {
                                businessNum: this.businessForm.businessCreditCode,
                                phone: this.businessForm.phone,
                                imgCode: this.businessForm.imgCode,
                                identifyCode: this.businessForm.msgCode,
                                type:2,
                            }
                            this.$http.post('/rest/api/dspUserApi/login', form).then(res => {
                                if (res.data.result) {
                                    this.__data__ = res.data.value
                                    let supplierUserInfo = this.__data__.supplierUserInfo
                                    if(supplierUserInfo.fisresetpsd){
                                        this.afterLogin()
                                    }else{
                                        window.sessionStorage.setItem('AuthorizationToken',this.__data__.token)
                                        this.setUserInfo(supplierUserInfo)
                                        this.firstBlood = true
                                    }
                                } else {
                                    this.message = res.data.message
                                    this.$alert(this.message)
                                }
                                this.$root.loading = false
                            } , err => {
                                this.$root.loading = false
                                this.$alert(err)
                            } )
                        }
                    })
                }else{
                    //todo
                    this.$refs[formName].validate(valid =>  {
                                            if (valid) {
                                                this.$root.loading = true
                                                window.adminLoginForm.username.value=this.loginForm.loginName;
                                                window.adminLoginForm.password.value=this.loginForm.password;
                                                window.adminLoginForm.submit();
                                                // this.$http.post('/admin/a/login','username=+'&password='+,
                                                // {"Content-Type":"application/x-www-form-urlencoded" }).then(res => {
                                                    // this.$root.loading = false
                                                    // this.$http.get('/admin/a/');
                                                // } , err => {
                                                    // this.$root.loading = false
                                                    // this.$alert(err)
                                                // } )
                                            }
                                        })
                }
            },
            afterLogin(){
                let data = this.__data__
                data.auditStep = +data.auditStep||1
                data.supplierStockInfo.farParent = data.farParent
                this.setUserInfo(data.supplierUserInfo)
                this.setBasicInfo(data.supplierStockInfo)
                window.sessionStorage.setItem('AuthorizationToken', data.token)
                window.sessionStorage.setItem('supplierUserInfo', JSON.stringify(data.supplierUserInfo))
                window.sessionStorage.setItem('supplierStockInfo', JSON.stringify(data.supplierStockInfo))
                window.sessionStorage.setItem('stockId', data.supplierStockInfo.id)
                window.sessionStorage.setItem('userId', data.supplierUserInfo.id)
                window.sessionStorage.setItem('auditStep', data.auditStep)
                this.$root.auditStep = data.auditStep
                this.$root.stockId = data.supplierStockInfo.id
                this.$root.userId = data.supplierUserInfo.id
                // this.$root.isPublic = false

                // userType !=0 屏蔽
                window.sessionStorage.setItem('loginUserType', data.supplierUserInfo.userType)
                this.$root.loginUserType = window.sessionStorage.getItem('loginUserType');
                // 标准清单 换title
                window.sessionStorage.setItem('inviteCompanyName', data.supplierStockInfo.fnameL2)

                // 为了解决抢登、重登后 GET id 中带'/'跳转404问题 转义了第二个斜杠之后的所有斜杠
                var _url = this.$route.query.redirect;
                if(_url) {

                    var isIn = false;
                    var openUrls = ['Index','Login', 'Forget','Register','RegisterNext','Help','Download', 'WinList','InviteInfo','InviteList','WinDetail','CarouseDetail','not-found', 'NoticeList','NoticeInfo','inviteList','inviteInfo'];
                    openUrls.forEach((data,index)=>{
                        if(_url.indexOf(data)!=-1) {
                            isIn = true
                        }
                    })

                    if( isIn ) {
                        this.$root.isPublic = true
                    } else {
                        this.$root.isPublic = false
                    }
                    console.log(isIn)

                    var _index = _url.indexOf('/',1);
                    if(_index!=-1) {
                        // _url = _url.replace(/\+/g,'%2B')  // 但 encodeURIComponent 会将 id 中的 '+' 转义成 %20 （即空格） 所以优先处理 '+'
                        var _trans = _url.substring(0, _index) + '/' + encodeURIComponent(_url.substring(_index + 1).replace('%20', '%2B'))
                        this.$router.push(_trans)
                        return
                    }
                }
                this.$router.push(this.$route.query.redirect||'/home')
            }
        },
        created(){
            this.$root.headImage.src=''
            this.$root.navs = []
            this.createRandomCode()
            if(this.$route.query.msg){
                this.$alert(this.$route.query.msg)
            }
        }
    }
</script>

<style scoped lang="postcss">
    @import '../../../assets/common.css';

    .login {
        min-width: 1200px;
        height: 720px;
        background: url("../../../assets/imgs/banner_login.png") no-repeat  top center;
    }
    .login .container-center {
        position: relative;
    }
    .login-inner {
        position: absolute;
        top: 105px;
        right: 0;
        width: 420px;
        font-size: 14px;
        background: #fff;
        border-radius: 5px;
    }
    .login-inner .login-type {
        width: 209px;
        height: 59px;
        float: left;
        padding: 16px 0 0;
        font-size: 18px;
        color: #aaa;
        text-align: center;
        list-style: none;
        border-left: 1px solid #d2d2d2;
        border-bottom: 1px solid #d2d2d2;
    }
    .login-inner .no-border {
        border-left: 0;
    }
    .login-inner .active {
        color: #f38619;
        border-bottom: 1px solid #fff;
    }
    .login-form {
        padding: 30px;
    }
    .login-form .form-title{
        display:flex;
        justify-content: space-between;
        align-items: center;
    }
    .welcome {
        color: #9595aa;
        font-size: 24px;
        padding-bottom: 23px;
    }
    .imgwarp {
        position: relative;
    }
    .imgwarp .validCodeImg,
    .imgwarp .verify-code{
        position: absolute;
        top: 6px;
        right:6px;
    }
    .login-form .submit {
        width: 100%;
        font-size: 20px;
    }
    .login-form .forget {
        color: #289cf4;
        text-decoration: underline;
        text-align: center;
    }
    .login-form .forget span {
        cursor: pointer;
    }
    .login-form .icon {
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        top: 8px;
        left: 10px;
        z-index: 1;
    }
    .login-form .icon-name {
        background: url('../../../assets/imgs/login_name.png') no-repeat center center;
    }
    .login-form .icon-pass {
        background: url('../../../assets/imgs/login_pass.png') no-repeat center center;
    }
    .login-form .icon-code {
        background: url('../../../assets/imgs/login_code.png') no-repeat center center;
    }
    .login-form .error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
    }
    .login-form .send-msg-col{
        padding-left:10px;
    }
    .login-form .send-msg-col .send-msg-btn{
        width:100%;
        height:40px;
    }
</style>
<style>
    .login-form .el-form-item {
        position: relative;
    }
    .login-form .el-form-item__label{
        position: absolute;
        top: 0;
        left: 43px;
        z-index: 1;
        text-align: left;
        width: auto !important;
    }
    .loginForm .el-form-item__label:before {
        display: none;
    }
    .loginForm .el-form-item__content {
        margin-left: 0 !important;
    }
    .loginForm .el-form-item__content input {
        padding-left: 80px;
    }
    .loginForm .imgwarp .el-form-item__content input {
        padding-left: 95px;
    }

    .loginForm .w-140 .el-form-item__content input{
        padding-left: 160px;
    }
    .loginForm .w-110 .el-form-item__content input{
        padding-left: 94px;
    }
    .loginForm .w-120 .el-form-item__content input{
        padding-left: 120px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/login/Login.vue